import { render, staticRenderFns } from "./WeightLabel.vue?vue&type=template&id=97aa0b60&"
import script from "./WeightLabel.vue?vue&type=script&lang=ts&"
export * from "./WeightLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports